import 'core-js/stable'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'

import ReactDOM from 'react-dom/client'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import store from 'store'

import App from './App'

const persistor = persistStore(store)

declare global {
  interface Window {
    Analytics: any
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
)
